
import configData from "../config.json";
import { ConfigData } from "../models/config";
const config = configData as ConfigData;

export class BaseService {

    
    constructor() {       
    }

    getEndPoint() : string {
        return config.API_URL;
    }

}